import React from "react";
import { Abm } from ".";

export const FormPrimitiva = (props) =>{
  const FormPrimitivas = Abm("primitivas");
  return <FormPrimitivas {...props}/>
} 